import { createApi } from '../callApi';
const contentApi = createApi('CONTENT');

export const updatePageSettings = (show, body) => {
    return contentApi({ method: 'PUT', target: `/v1/shows/${show}/page/settings`, body });
};
export const fetchPageSettings = (show) => {
    return contentApi({ method: 'GET', target: `/v1/shows/${show}/page/settings` });
};
